module.exports = __webpack_public_path__ + "img/my-searches.e51c6c6b.png";